import { createTranslationsPageProvider } from '@edreamsodigeo/frontend-core';
export const ShellErrorTranslationsProvider = createTranslationsPageProvider({
  flightResults: ({
    brand,
    locale
  }) => import(/* webpackChunkName: "i18n-fea-[request]" */`@edreamsodigeo/frontend-flights-results/translations/${brand}/${locale}/shell_errors.js`)
});